import { useLocale } from "../../../intl";
import { getBuyerChecklistHubCopy } from "../../../intl/automotiveCopy";
import "../../../styles/buyerChecklist.css";

export default function ChecklistProgress({ progress, className = "" }) {
  const { t } = useLocale();
  const copy = getBuyerChecklistHubCopy(t);
  const { checked = 0, total = 0, percent = 0 } = progress || {};

  return (
    <div className={`buyer-checklist-progress ${className}`.trim()} aria-live="polite">
      <div className="buyer-checklist-progress__bar" aria-hidden="true">
        <span className="buyer-checklist-progress__fill" style={{ width: `${percent}%` }} />
      </div>
      <p className="buyer-checklist-progress__text">
        {total ? copy.progressCompleted(checked, total, percent) : copy.progressEmpty}
      </p>
    </div>
  );
}
